import { createFeatureSelector, createSelector } from "@ngrx/store";
import { simulationSettingFeatureKey } from "./simulation-setting.reducer";

export const selectSimulationSettingState = createFeatureSelector(simulationSettingFeatureKey);

export const selectSimulationSetting = createSelector(
  selectSimulationSettingState,
  (state: any) => state
);
